import styled, {css} from "@yb/styled-px2rem";

const CotentBox = styled.div`
	padding: 30px 15px;
	background: #fff;
	text-align: left;
`;

const Subject = styled.h5`
	font-size: 18px;
	color: var(--emp-color);
`;

const RequiredGuide = styled.span`
	position: relative;
	display: block;
	line-height: 1;
	margin-bottom: 15px;
	font-size: 12px;
	text-align: right;
	color: var(--default-color);
	&::before {
		display: inline-block;
		margin-right: 3px;
		vertical-align: middle;
		color: var(--red-color);
		content: "*";
	}
`;

const Table = styled.table`
	th {
		display: inline-block;
		width: 100%;
		padding-bottom: 15px;
		font-weight: bold;
		color: var(--emp-color);
	}

	td {
		display: inline-block;
		width: 100%;
		padding-bottom: 30px;
	}

	tr {
		display: inline-block;
		width: 100%;
		tr:last-child td {
			padding-bottom: 0;
		}
	}
`;

const InputRow = styled.div<{wrong?: boolean}>`
	width: 100%;
	${props =>
		props.wrong
			? css`
					> p {
						display: block;
						margin-top: 10px;
					}
					input:not([type="checkbox"]),
					select,
					textarea {
						border-color: red;
					}
					input:focus {
						border-color: var(--emp-color);
					}
			  `
			: css`
					> p {
						display: none;
					}
			  `}
`;

const MailWrap = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	> span {
		display: inline-block;
		width: 20px;
		padding: 0 5px;
		line-height: 40px;
		font-size: 15px;
		text-align: center;
	}
	> div {
		margin-top: 10px;
	}
`;

const CheckBoxWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	> span {
		display: flex;
		align-items: center;
		label {
			margin-right: 10px;
			font-weight: normal;
		}
	}
`;

const ByteText = styled.span`
	font-size: 12px;
	color: var(--default-color);
`;

const BulletList = styled.ul`
	> li {
		line-height: 24px;
		font-size: 15px;
		color: var(--default-color);
		&::before {
			top: 9px;
		}
	}
`;

const InfoBox = styled.div`
	padding: 30px 15px;
	margin-top: 30px;
	background: #f3f3f3;
`;

const ArticleListItem = styled.li`
	display: flex;
	> strong {
		flex: 0 0 auto;
		padding: 5px 0 4px 0;
		word-break: keep-all;
		color: var(--emp-color);
	}
	> span {
		padding: 3px 0 2px 20px;
	}
`;

const CheckWrap = styled.div`
	display: flex;
	margin-top: 15px;
	> input {
		flex: 0 0 auto;
	}
	> label {
		flex: 1 1 auto;
		line-height: 25px;
		margin-left: 10px;
		font-size: 15px;
	}
	+ span {
		padding-left: 35px;
	}
`;

const BtnArea = styled.div`
	margin-top: 30px;
`;

const InfoText = styled.span`
	display: block;
	line-height: 1;
	font-size: 12px;
	text-align: right;
	> span {
		margin-right: 4px;
	}
`;

const RequiredIcon = styled.span`
	display: inline-block;
	height: 0px;

	&::before {
		display: inline;
		color: var(--red-color);
		content: "*";
	}
`;

export {
	ArticleListItem,
	BtnArea,
	BulletList,
	ByteText,
	CheckBoxWrap,
	CheckWrap,
	CotentBox,
	InfoBox,
	InputRow,
	MailWrap,
	RequiredGuide,
	Subject,
	Table,
	InfoText,
	RequiredIcon,
};
